const Rivers = {
  url: 'get/river/',
  title: 'رودخانه',
  parameters: ['id', 'name', 'lat', 'lng'],
};

const Hydrometric = {
  url: 'get/hydrometric_station/',
  title: 'ایستگاه هیدرومتری',
  parameters: ['id', 'name', 'lat', 'lng', 'code'],
};

const Synoptic = {
  url: 'get/synoptic_station/',
  title: 'ایستگاه سینوپتیک',
  parameters: ['id', 'name', 'lat', 'lng', 'code'],
};

const Dam = {
  url: 'get/dam/',
  title: 'سد',
  parameters: ['id', 'name', 'lat', 'lng', 'dam_type'],
};

const DamHumanDetail = {
  url: 'get/dam_human_detail/',
  title: 'جزئیات سد',
  parameters: ['id', 'dam_item', 'dam'],
};

const WeatherStation = {
  url: 'get/weather_station/',
  title: 'ایستگاه هواشناسی',
  parameters: ['id', 'name', 'lat', 'lng', 'code'],
};

const Aquifer = {
  url: 'get/aquifer/',
  title: 'آبخوان',
  parameters: ['id', 'area'],
};

const Watershed = {
  url: 'get/watershed/',
  title: 'آبریز',
  parameters: ['id', 'name', 'lat', 'lng'],
};

const Lake = {
  url: 'get/lake/',
  title: 'دریاچه',
  parameters: ['id', 'name', 'lat', 'lng'],
};

const SnowDetail = {
  url: 'get/snow_detail/',
  title: 'برف',
  parameters: ['id', 'weather_station'],
};

export const GetTypes = {
  Rivers: Rivers,
  Hydrometric: Hydrometric,
  Synoptic: Synoptic,
  Dam: Dam,
  DamHumanDetail: DamHumanDetail,
  WeatherStation: WeatherStation,
  Aquifer: Aquifer,
  Watershed: Watershed,
  Lake: Lake,
  SnowDetail: SnowDetail,
};

export const GetTypesTitles = [
  'Rivers',
  'Hydrometric',
  'Synoptic',
  'Dam',
  'DamHumanDetail',
  'WeatherStation',
  'Aquifer',
  'Watershed',
  'Lake',
  'SnowDetail',
];
